import moment from "moment";
import { useReducer } from "react";
import { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import { IHomePageSectionsArrangement } from "../../models/arrange_sections_page_home/request";
import { IHomePageSectionsArrangementQuery } from "../../models/arrange_sections_page_home/query";
import HomePageSectionsArrangementContext from "./context";
export interface IProps {
  children: React.ReactNode;
}

const HomeHomePageSectionsArrangementContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.homePageSectionsArrangement.getAllHomePageSectionsArrangementLists(
            {
              ...state.query,
              // perPage: -1
            }
        );

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const updateHomePageSectionsArrangement = async (
    id: number,
    request: IHomePageSectionsArrangement
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.homePageSectionsArrangement.updateHomePageSectionsArrangementList(id, request);

        // getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };
  const createHomePageSectionsArrangement = async (
    request: IHomePageSectionsArrangement
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        await EndPoints.homePageSectionsArrangement.createHomePageSectionsArrangement(request);

        // getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const setQuery = (query: IHomePageSectionsArrangementQuery) => {
      dispatch({ type: "SET_QUERY", payload: { query } });
    };
  const deleteHomePageSectionsArrangement = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.homePageSectionsArrangement.deleteHomePageSectionsArrangement(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };
  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };
  return (
    <HomePageSectionsArrangementContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          updateHomePageSectionsArrangement,
          createHomePageSectionsArrangement,
          deleteHomePageSectionsArrangement,
          setQuery,
          setSearch
        },
      }}
    >
      {props.children}
    </HomePageSectionsArrangementContext.Provider>
  );
};

export default HomeHomePageSectionsArrangementContextProvider;
